import CreationToolSuperCutField from '../../../types/super-cut-field'
import { CropEditorIcon, WatermarkEditorIcon } from '../../icons'

type Props = {
    field: CreationToolSuperCutField
}

const CreationToolSuperCutFieldIcon = ({ field }: Props) => {
    switch (field) {
        case CreationToolSuperCutField.Caption:
            return <i className="giphyicon-gif-caption" />
        case CreationToolSuperCutField.CaptureTitle:
            return <i className="ss-text" />
        case CreationToolSuperCutField.Watermark:
            return <WatermarkEditorIcon colors={['#5C5C5C', '#5C5C5C']} />
        case CreationToolSuperCutField.Font:
            return <i className="ss-font" />
        case CreationToolSuperCutField.Crop:
            return <CropEditorIcon colors={['#5C5C5C', '#5C5C5C']} />
        case CreationToolSuperCutField.SegmentaionTiming:
            return <i className="ss-clock" />
        case CreationToolSuperCutField.CaptionPosition:
        case CreationToolSuperCutField.CaptionStyle:
        case CreationToolSuperCutField.SegmentationType:
        case CreationToolSuperCutField.WatermarkFile:
        case CreationToolSuperCutField.WatermarkPreview:
        case CreationToolSuperCutField.WatermarkPosition:
            return null
        default:
            return null
    }
}

export default CreationToolSuperCutFieldIcon
